const globals = {
  baseUrl: 'https://pos-apis.divisiononeservices.com.au/api',
  businessId: localStorage.getItem('business_id'),
};

export default globals;